<template>
  <div class="bs-docs-section mx-3 my-3 page-wrap">
    <div class="tc-section">
      <div class="row">
        <div class="col-md-12 text-center mb-2 pt-1">
          <h4>Disclaimer</h4>
          <hr class="w-80" />
        </div>
      </div>

      <p class="c1">
        <span class="c2"
          >This Website is owned and maintained by Finult Advisors Private
          Limited (referred to as &quot;Finult&quot; hereafter) for your
          personal information, communication, education and use. The Website
          may contain links to other websites, having further linked websites,
          operated by parties other than Finult (&quot;Linked
          Websites&quot;).</span
        >
      </p>
      <p class="c1">
        <span class="c2"
          >The use of Website is governed by the following terms and conditions
          and other terms and conditions/policies as indicated on this Website
          (&quot;T &amp; C&quot;) and all the applicable laws as also any
          separate terms and conditions for certain sections as may be
          applicable and in the event of any conflict such specific terms and
          conditions shall prevail. Any or all users of this system and files
          are being tracked and by accessing and using Website you agree to
          accept, without limitation or qualification, all the T &amp; C. The
          Content (information, material, news items, data, etc.) of the Website
          including the T &amp; C are subject to change at the sole discretion
          of Finult, without prior notice.</span
        >
      </p>
      <p class="c1">
        <span class="c2"
          >Finult owns all the right, title and interest including the copyright
          in respect of all the Content including various logos, trademarks,
          service marks etc., unless indicated otherwise. You may use/download
          the Content only for non-commercial and personal use, provided you
          retain all copyright and other proprietary notices contained therein.
          You shall not, however, reproduce, distribute, redistribute, modify,
          transmit, reuse, report, or use the Content for public or commercial
          purposes without Finult&rsquo;s written permission. You shall not use
          the Content for illegal purpose.</span
        >
      </p>
      <p class="c1">
        <span class="c2"
          >Products and services offered on the Website are available only in
          restricted geographical regions as indicated. This Website does not
          offer any products or services to citizens of or in the jurisdictions
          whose laws conflict with, differ from, or provide higher requirements
          than those necessitated by, the laws of the Republic of India.</span
        >
      </p>
      <p class="c1">
        <span class="c2"
          >The development of the Website with respect to the Content and
          software made available and products and services
          (&quot;Products&quot;) offered through it, is a continuous and an
          ongoing process and Products are provided on &quot;best effort
          basis&quot;. Finult makes all attempts to keep the Products and/or
          services updated and accurate, but Products and/or services may not be
          up to date. Finult makes no warranty or representation, express or
          implied, including, but not limited to any warranties or
          representations as to the accuracy, reliability or completeness of the
          Products and/or fitness for a particular purpose, and/or
          non-infringement with respect to the Website and/or Linked Websites
          and/or the Products.</span
        >
      </p>
      <p class="c4">
        <span class="c2"
          >Any Content on Website must not be construed as advice, and you
          should exercise due caution and/or seek sp0ecific advice before
          entering into any obligation, financial or otherwise, based on the
          Content. The contents displayed or the products/services offered on
          the Linked Websites or any quality of the same are not endorsed,
          verified or monitored by Finult in any way. Finult makes no
          representation or warranty, express or implied, of any kind
          whatsoever, pertaining to the Linked Websites.</span
        >
      </p>
      <p class="c4">
        <span class="c2"
          >Though Finult takes steps to prevent introduction of virus and other
          such destructive materials on the Website, it does not represent,
          warrant or guarantee that the Website or the Content downloaded from
          the Website or Linked Websites do not contain such virus or
          destructive materials. Finult is and shall not be liable for any
          damage or harm attributable to such virus or destructive materials.
          Finult does not warrant that the Website or functions thereof will be
          uninterrupted or free of any error or defect. Finult shall not be
          liable to you or any third party (whether or not the access is
          authorised) for any cost, loss, damage or the like, incurred /
          suffered, directly or indirectly, due to:</span
        >
      </p>
      <ul class="c3 lst-kix_list_3-0 start">
        <li class="c16">
          <span class="c2"
            >Use of the Websites or Products/services in violation of the
            applicable terms and conditions of such usage or the applicable laws
            or otherwise failure to abide by such terms and conditions or
            laws.</span
          >
        </li>
        <li class="c0">
          <span class="c2"
            >Any action based on the Content or any use or application of the
            same or any error or omission relating to the transmission of the
            Content.</span
          >
        </li>
      </ul>
      <ol type="i">
        <li class="c7">
          <span class="c2"
            >Finult&rsquo;s Failure to act upon your instructions,
          </span>
        </li>
        <li class="c7">
          <span class="c2"
            >Non availability of the Internet Services in the desired
            manner,</span
          >
        </li>
        <li class="c7">
          <span class="c2"
            >loss of any instruction in any communication channel or of any
            stored data/instructions; due to any reasons beyond the control of
            Finult at the relevant point of time, including any problems and
            difficulties arising due to power and electricity failure, computer
            errors, programming errors, software or hardware errors, computer
            breakdown, non-availability of Internet connection, communication
            problems between the website and User&#39;s computer network,
            non-availability of links, corruption of the computer software,
            problems in the telecommunication network and any other technology
            related problems, natural calamities/ disasters, legal restraints,
            industrial disputes, epidemic/pandemic or any other reason beyond
            the control of Finult.</span
          >
        </li>
      </ol>
      <ul class="c3 lst-kix_list_3-0">
        <li class="c0">
          <span class="c2"
            >Any unauthorised transaction through this Website due to your
            fraudulent or negligent usage.</span
          >
        </li>
        <li class="c19">
          <span class="c2"
            >Any unauthorised / fraudulent / erroneous use of or hacking or
            intrusion into the computer network of Finult by any third party due
            your negligent or fraudulent conduct, or if Finult has taken due and
            reasonable care to avoid such hacking or intrusion.</span
          >
        </li>
      </ul>
      <p class="c4">
        <span class="c2"
          >You or any third party accessing the Website irrevocably agrees to
          the exclusive jurisdiction of the courts at Bangalore in relation any
          matter connected or related to use or access of the Website and waives
          any objection to any proceedings on grounds of venue or on the grounds
          that the proceedings have been brought in an inconvenient forum. The
          governing law in such legal proceedings referred to above shall be the
          laws of the Republic of India.</span
        >
      </p>
      <p class="c1">
        <span class="c2"><strong>Additional Disclaimer</strong></span>
      </p>
      <p class="c4">
        <span class="c2"
          ><br />This communication is confidential and privileged and is
          directed to and for the use of the addressee only.</span
        >
      </p>
      <p class="c4">
        <span class="c2"
          >The recipient acknowledges that Finult Advisors Private Limited may
          be unable to exercise control or ensure or guarantee the integrity of
          the text of the email message and the text is not warranted as to
          completeness and accuracy.</span
        >
      </p>
      <p class="c4">
        <span class="c2"
          >Copyright Finult Advisors Private Limited. All rights reserved.</span
        >
      </p>
      <p class="c13"></p>
      <p class="c13 c14">
        <span class="c2"></span>
      </p>
      <p class="c13 c14">
        <span class="c2"></span>
      </p>
      <p class="c1">
        <span class="c2"><strong>Privacy Policy</strong></span>
      </p>
      <p class="c4">
        <span class="c2"
          >You agree that we may use Customer Information for the purpose of
          statistical analysis and for creation of data (&quot;Statistical
          Information&quot;), which does not contain individual Customer
          Information. In addition to the information that Finult elicits from
          you, you are free to volunteer any other information that you feel
          that Finult needs to know, but the security and confidentiality as per
          this Policy is guaranteed only to the information that the Finult
          directly asks from you.</span
        >
      </p>
      <p class="c4">
        <span class="c2"
          >This Policy holds true for a non-customer who has provided
          information to Finult, by any means, with the intentions of
          establishing a relationship, of whatsoever nature, with Finult. By
          divulging any information to us you agree to the terms and conditions
          of this Policy.</span
        >
      </p>
      <p class="c4">
        <span class="c2"
          ><br />Use of Customer Information / Statistical Information</span
        >
      </p>
      <p class="c4">
        <span class="c2"
          >We may use the Customer Information for, among other things, customer
          verification, provision of products and services, for personalization
          of products or services, marketing or promotion of our financial
          services or related products or that of our associates and affiliates;
          for creation of Statistical Information, statistical analysis,
          enforcement of your obligations, any other purpose that will help us
          in providing you with optimal and high quality services.</span
        >
      </p>
      <p class="c4">
        <span class="c2"><br /><strong>Security</strong></span>
      </p>
      <p class="c4">
        <span class="c2"
          >We have taken reasonable measures to protect security and
          confidentiality of the Customer Information and its transmission
          through the World Wide Web. You are required to follow the Terms and
          Conditions while using this Website including the instructions
          stated.</span
        >
      </p>
      <p class="c4">
        <span class="c2"
          >Finult will give access to Customer Information to employees and
          associates of Finult for enforcement of your obligations. Any employee
          who withdraws from the employment of Finult will have to undertake to
          abide by this Privacy Policy and keep all Customer Information secure
          and confidential.</span
        >
      </p>
      <p class="c4">
        <span class="c2"><br /><strong>Disclosure</strong></span>
      </p>
      <ul class="c3 lst-kix_list_4-0 start">
        <li class="c16">
          <span class="c2"
            >We shall not be held liable for disclosure of the Customer
            Information or Statistical Information in accordance with this
            Privacy Commitment or in terms of any other agreements with
            you.</span
          >
        </li>
        <li class="c0">
          <span class="c2"
            >We may disclose the Statistical Information to any person, without
            any limitation and you hereby give your irrevocable consent for the
            same.</span
          >
        </li>
        <li class="c0">
          <span class="c2"
            >We may disclose Customer Information to any of our associates and
            affiliates, without any limitation and you hereby give your consent
            for the same.</span
          >
        </li>
        <li class="c0">
          <span class="c2"
            >We may disclose the Customer Information, to third parties, without
            limitation, for the following reasons and you hereby give your
            irrevocable consent for the same:-</span
          >
        </li>
      </ul>
      <ul class="c3 lst-kix_list_4-2 start">
        <li class="c12">
          <span class="c2"
            >To comply with legal requirements, legal process, legal or
            regulatory directive/ instruction. or</span
          >
        </li>
        <li class="c12">
          <span class="c2"
            >To enforce the Terms and Conditions of the products or services.
            or</span
          >
        </li>
        <li class="c12">
          <span class="c2"
            >To protect or defend our rights, interests and property or that of
            our associates and affiliates, or that of our or our Affiliate&#39;s
            employees, consultants etc. or</span
          >
        </li>
        <li class="c12">
          <span class="c2">As permitted or required by law.</span>
        </li>
      </ul>
      <ul class="c3 lst-kix_list_4-0">
        <li class="c0">
          <span class="c2"
            >We may disclose the Customer Information to third parties for
            following, among other purposes, and will make reasonable efforts to
            bind them to obligation to keep the same secure and confidential and
            an obligation to use the information for the purpose for which the
            same is disclosed, and you hereby give your irrevocable consent for
            the same:-</span
          >
        </li>
      </ul>
      <ul class="c3 lst-kix_list_4-2 start">
        <li class="c12">
          <span class="c2"
            >For participation in any telecommunication or electronic clearing
            network. or</span
          >
        </li>
        <li class="c12"><span class="c2">For advertising. or</span></li>
        <li class="c12">
          <span class="c2"
            >For facilitating joint product promotion campaigns. or</span
          >
        </li>
        <li class="c12">
          <span class="c2"
            >For availing of the support services from third parties. or</span
          >
        </li>
        <li class="c5">
          <span class="c2"
            >For sharing with third-parties information obtained with your
            consent, from your mobile device like device location, device
            information (including storage, model, installed apps, wifi, mobile
            network) transactional and promotional SMS, communication
            information including contacts and call logs, for statistical
            modelling, credit scoring and any other purpose that will help us in
            providing you with optimal and high quality services</span
          >
        </li>
      </ul>
      <p class="c4 c8">
        <span class="c2"
          ><strong><br />Cookie Policy</strong></span
        >
      </p>
      <p class="c4">
        <span class="c2"
          >To continually enhance your online experience, we use cookies that
          store your preferences and give us data about your browsing behaviour,
          such as the pages you visited on this website, how much time you spent
          on our site, etc. This information helps us understand customer
          interests and helps us improve our website. By visiting the website,
          you acknowledge, accept and expressly authorize us for the placement
          of cookies on your computer or hand held device. Please find below
          some more information regarding cookies and their application on our
          website:</span
        >
      </p>
      <p class="c4">
        <span class="c2"><br />What are Cookies?</span>
      </p>
      <p class="c4">
        <span class="c2"
          >A cookie is a simple text file that is stored on your computer or
          mobile device by a website&rsquo;s server and only that server will be
          able to retrieve or read the contents of that cookie. Every cookie is
          unique to your particular web browser. It will contain some anonymous
          information such as a unique identifier and the site name with some
          digits and numbers. It allows the website to remember your browsing
          behaviour &amp; show you relevant ads based on the browsing pattern.
          The cookies also allow the website to limit the number of ads
          shown.</span
        >
      </p>
      <p class="c4">
        <span class="c2"><br />How does Finult.com use Cookies?</span>
      </p>
      <p class="c4">
        <span class="c2"
          >Finult.com uses cookies to capture following information
          &ndash;</span
        >
      </p>
      <ul class="c3 lst-kix_list_5-0 start">
        <li class="c15">
          <span class="c2">Source of visit to the website</span>
        </li>
        <li class="c13 c18">
          <span class="c2">Time spent on the website</span>
        </li>
        <li class="c13 c18">
          <span class="c2">Pages viewed on the website</span>
        </li>
        <li class="c10"><span class="c2">Ad clicks</span></li>
      </ul>
      <p class="c4">
        <span class="c2"
          >Please note that the scope of this tracking is limited to the
          Finult.com domain. User activity on other third-party websites is not
          tracked by Finult.com cookies.</span
        >
      </p>
      <p class="c4">
        <span class="c2"><br />Further information about cookies</span>
      </p>
      <p class="c4">
        <span class="c6"
          >If you&rsquo;d like to learn more about cookies in general and how to
          manage them, visit</span
        ><span class="c11">&nbsp;</span
        ><span class="c6 c9"
          ><a class="c20" href="http://www.aboutcookies.org" target="_blank">
            www.aboutcookies.org
          </a></span
        ><span class="c11">&nbsp;</span
        ><span class="c2"
          >(opens in a new window &ndash; please note that we can&rsquo;t be
          responsible for the content of external websites).</span
        >
      </p>
      <p class="c4">
        <span class="c2"><br />Changes to this policy</span>
      </p>
      <p class="c4">
        <span class="c2"
          >The above may change at any time. We will endeavour to notify you of
          any major changes but you may wish to check it each time you visit our
          website.</span
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsAndConditions",
  metaInfo: {
    title: "Terms & Conditions"
  },
  data() {
    return {};
  }
};
</script>

<style>
.tc-section {
  font-family: "Times New Roman", Times, serif;
  margin-left: 100px;
  margin-right: 100px;
  line-height: 1.6;
}

@media (max-width: 600px) {
  .tc-section {
    margin-left: 0px;
    margin-right: 0px;
    line-height: 1.2;
  }
}
ol {
  margin: 0;
  padding: 0;
}
.c7 {
  margin-left: 72pt;
  padding-top: 0pt;
  padding-left: 18pt;
  padding-bottom: 0pt;

  orphans: 2;
  widows: 2;
  text-align: justify;
}
.c15 {
  margin-left: 25.1pt;
  padding-top: 15pt;
  padding-left: -3.8pt;
  padding-bottom: 0pt;

  orphans: 2;
  widows: 2;
  text-align: justify;
}

.c0 {
  margin-left: 12pt;
  padding-top: 0pt;
  padding-left: 0pt;
  padding-bottom: 0pt;

  orphans: 2;
  widows: 2;
  text-align: justify;
}

.c5 {
  margin-left: 67.7pt;
  padding-top: 0pt;
  padding-left: 10.3pt;
  padding-bottom: 15pt;

  orphans: 2;
  widows: 2;
  text-align: justify;
}

.c16 {
  margin-left: 12pt;
  padding-top: 15pt;
  padding-left: 0pt;
  padding-bottom: 0pt;

  orphans: 2;
  widows: 2;
  text-align: justify;
}

.c10 {
  margin-left: 25.1pt;
  padding-top: 0pt;
  padding-left: -3.8pt;
  padding-bottom: 15pt;

  orphans: 2;
  widows: 2;
  text-align: justify;
}

.c19 {
  margin-left: 12pt;
  padding-top: 0pt;
  padding-left: 0pt;
  padding-bottom: 15pt;

  orphans: 2;
  widows: 2;
  text-align: justify;
}

.c12 {
  margin-left: 67.7pt;
  padding-top: 0pt;
  padding-left: 10.3pt;
  padding-bottom: 0pt;

  orphans: 2;
  widows: 2;
  text-align: justify;
}

.c2 {
  color: #271117;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-style: normal;
}

.c1 {
  padding-top: 15pt;
  padding-bottom: 7.5pt;

  orphans: 2;
  widows: 2;
  text-align: justify;
}

.c13 {
  padding-top: 0pt;
  padding-bottom: 0pt;

  orphans: 2;
  widows: 2;
  text-align: justify;
}

.c4 {
  padding-top: 0pt;
  padding-bottom: 7.5pt;

  orphans: 2;
  widows: 2;
  text-align: justify;
}

.c11 {
  color: #271117;
  font-weight: 400;
}

.c6 {
  color: #271117;
  font-weight: 400;
}

.c9 {
  -webkit-text-decoration-skip: none;
  text-decoration: underline;
  text-decoration-skip-ink: none;
}

.c17 {
  background-color: #ffffff;
  padding: 53.8pt 60pt 52.4pt 72pt;
  color: #333333 !important;
  /*font-family: "ScalaSans RegularCn";*/
  font-size: 18px;
}

.c3 {
  padding: 0;
  margin: 0;
}

.c18 {
  margin-left: 25.1pt;
  padding-left: -3.8pt;
}

.c20 {
  color: inherit;
  text-decoration: inherit;
}

.c8 {
  margin-right: 7.1pt;
}

li {
  color: #000000;
}

@media (max-width: 640px) {
  .c17 {
    font-size: 14pt;
    padding-left: 5%;
    padding-right: 5%;
  }
  .c12,
  .c7,
  .c5 {
    margin-left: 35pt;
  }
}
</style>
